/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SqlEngineStatus } from '../models/SqlEngineStatus';

export class SqlEngine {
  /**
  * The unique identifier of the SQL engine
  */
  'id': string;
  /**
  * The name of the SQL engine
  */
  'name': string;
  /**
  * The type of the SQL engine
  */
  'engineType': string;
  'status': SqlEngineStatus;
  /**
  * The timestamp when the SQL engine was created
  */
  'createdAt': Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "engineType",
      "baseName": "engineType",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "SqlEngineStatus",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return SqlEngine.attributeTypeMap;
  }

  public constructor() {
  }
}



